export const getNumberOptions = (to) => {
  let salida = [];
  for (let i = 1; i <= to; i++) {
    salida = [...salida, { text: i, value: i }];
  }
  return salida;
};
